import { useIntl } from 'react-intl';

import { IllustrationEmptyStateError } from '@xing-com/illustrations';

import { EmptyState } from '.';

export const ErrorState = ({ ...props }): JSX.Element => {
  const intl = useIntl();

  return (
    <EmptyState
      bodyCopyText={intl.formatMessage({
        id: 'XDS_EMPTYSTATE_ERROR_DESCRIPTION',
      })}
      buttonText={intl.formatMessage({ id: 'XDS_EMPTYSTATE_ERROR_BUTTON' })}
      headlineText={intl.formatMessage({ id: 'XDS_EMPTYSTATE_ERROR_TITLE' })}
      illustration={IllustrationEmptyStateError}
      {...props}
    />
  );
};
